import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <CardsSection />
        <IndexSection />
        <UpdatesSection />
        <AboutSection />
        <CommentsSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}